import React from "react";
import styled from "styled-components";
import NoProfile from "../../assets/no-profile.png";
import UniProfileLogout from "./UniProfileLogout";
import UniProfileLogin from "./UniProfileLogin";

const ProfileLayout = styled.div`
  position: relative;
  z-index: 901;
  .background-profile {
    z-index: 901;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: auto;
  }
  .profile-menu {
    z-index: 903;
    cursor: auto;
    overflow: hidden;
    display: flex;
    direction: rtl;
    white-space: nowrap;
    flex-direction: column;
    position: fixed;
    top:60px;
    left: calc(var(--padding) + 4.5rem);
    width: 15.2rem;
    max-height: 0rem;
    background-color: var(--body-2);
    color: var(--text-2);
    text-align: right;
    padding: 0;
    border-radius: var(--border-radius-2);
    backdrop-filter: blur(15px);
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
    transition: all 0.3s ease-in-out;
    &.proHome2{    
      top: 65px;
      left:var(--padding) ;
    }
    &.active {
      max-height: 19rem;
      padding: 1rem;
    }
    &.out{
      display: none;
    }
    &.active2 {
      max-height: 20rem;
      left:0;
    }
    .top-user {
      display: flex;
      flex-direction: row;
      height: 40px;
      .text {
        flex-grow: 1;
        color: var(--gray-5);
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title ,.sub-title{
          font-size: 1.25rem;
          font-weight: 600;
        }
      }
    }
    .sub-title2 {
      display: flex;
      margin-right:1rem;
      color:  var(--gray-5);
      font-size: 1.25rem;
      font-weight: 600;
      .name{
        padding-left:  0.2rem;
      }
    }
    .part {
      margin: 0.5rem 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 1rem ;
      width: calc(100% - 2rem);
      text-decoration: none;
      color: var(--gray-8) ;
      .link-icon{
        fill: var(--gray-8);
        width: 24px;
        height: 24px;
        padding: 0;
      }
      .title {
        padding: 1rem 0 0;
        text-align: right;
      }
      .link {
        flex-grow: 1;
        text-decoration: none;
        color: var(--gray-8) ;
        margin:0 0.5rem ;
        font-size:1rem ;
        cursor: pointer;
        font-weight: 500;
      }
      /* .singup {
        border: 2px solid var(--primary-1) ;
        color: var(--primary-1) ;
        background: var(--body-2) ;
      } */
      .last-link {
        flex-grow: 1;
        color: var(--secondry-5);
        text-decoration: none;
        font-weight: 500;
        font-size: 1rem;
        margin:0 0.5rem ;
        
      }
    }
  }

  .profile-menu .avatar-container {
    display: flex;
    height: 5rem;
    text-decoration: none;
    color: var(--text-2);
    :hover {
      color: var(--text-2);
    }
    .avatar {
      align-self: center;
      justify-self: center;
      border-bottom: solid 1px #aaa;
      width: 110px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #ddd;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .data {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      margin: 0 0.5rem 0 0;
      justify-content: center;
      .row {
        font-weight: 600;
      }
      .row-small {
        font-weight: normal;
        font-size: 0.6rem;
      }
    }
  }
  .profile-menu .button {
    padding: 0.5rem 0;
    border-bottom: solid 1px #aaa;
  }
  .profile-menu .button a {
    color: var(--text-2);
    text-decoration: none;
  }
  .profile-menu .button a:hover {
    color: var(--text-2);
  }
  @media screen and (max-width: 850px) {
    display: flex;
    flex-direction: row;
    .profile-menu {
      width: 100vw;
      top: 0;
      left: 0;
      padding: 0 1rem;
      &.proHome2{    
        top: auto;
        left:auto;
      }
      &.active{
        padding:0.5rem 0;
      }
      &.active2 {
        max-height: 22rem;
        left: 0px;
      }
      .top-user {
        display: block;
        .icon {
          margin: 0;
          padding: 0rem 2rem 0;
          .nav-link {
            flex-grow: 1;
            text-decoration:none;

            svg,
            img {
              width: 2rem;
              height: 2rem;
              transform: scale(0.8, 0.8);
            }
            .sub-title1 {
              font-size: var(--fs-nav-login-name);
              font-weight: 800;
              margin-right: 0.2rem;
              padding-top: 0.5rem;
              display: flex;
              .link{
                text-decoration: none;
                font-size: var(--fs-nav-login-name);
                font-weight: 800;
                color: var(--text-2);
              }
            }
          }
          .notif{
            margin: 0;
            font-size: 2rem;
            svg{
              width: 100%;
            }
          }
          .top-icon {
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: flex-end;
            padding: 0;
            margin: auto;
          }
          
          .nav-link .small-number {
            top: 1.3rem;
            margin: auto;
          }
          .notif{
            left: 0.5rem;
            right: auto !important;
          }

          .top-icon-cart svg {
            margin: auto;
          }
          .cls {
            display: flex !important;
            cursor: pointer;
            margin-left: 0;
            flex-grow: 1;
            svg {
              width: 2.5rem;
              margin-right: 2rem;
            }
          }
        }
        .text {
          text-align: start;
          padding: 0;
         
        }
      }
      
    }
  }


`;

class UniProfile extends React.Component {
  constructor(props) {
    super(props);
    let token = localStorage.getItem("token");
    let temp_logined = false;
    if (token !== null) {
      temp_logined = true;
    }
    this.state = {
      logined: temp_logined,
      home: false,
    };
  }

  showProfileHome = () => {
    if (window.innerWidth < 840) {
      this.setState({
        home: !this.state.home,
      });
    }
  };
  getAvatar() {
    if (this.props.userdata.avatar) {
      return (
        <img
          className="avatar"
          src={this.props.userdata.avatar}
          alt="profile-avatar"
        />
      );
    } else {
      return <img className="avatar" src={NoProfile} alt="profile-avatar" />;
    }
  }
  getElements() {
    if (this.props.userdata) {
      let username = "";
      if (this.props.userdata.U_FNAME) {
        username = this.props.userdata.U_FNAME;
      } else {
        username = this.props.userdata.mobile;
      }
      let usertype = parseInt(this.props.userdata.usertype);
      return (
        <UniProfileLogin {...this.props} func={this.props.func} count={this.getAllCount()} showProfile={this.showProfileHome} username={username} usertype={usertype} notif={this.props.notif}/>
      );
    } 
    // else {
    //   return (
    //     <UniProfileLogout {...this.props} func= {this.props.func} count={this.getAllCount()} showProfile={this.showProfileHome}/>
    //   );
    // }
  }

  render() {
  
    let classes = "profile-menu top-icon";
    if (this.props.location === "/") {
      classes = "profile-menu home top-icon ";
    }
    if (this.props.state) {
      classes = "profile-menu top-icon active ";
      if(!this.props.userdata){
        classes = "profile-menu top-icon active out";
      }
      if (this.props.location === "/") {
        classes = "profile-menu home top-icon active2";
      }
    }
    return (
      <ProfileLayout>
        {this.props.state && (
          <div className="background-profile" onClick={this.props.func}></div>
        )}
        <div id="uni-profile-menu" className={classes +' ' + this.props.classname}>
          {this.getElements()}
        </div>
      </ProfileLayout>
    );
  }
  getAllCount = () => {
    if (this.props.loading) {
      let cart = this.props.cart;
      let count = 0;
      cart.forEach((value) => {
        count += value.TEMP_BASK_COUNT;
      });
      return count;
    } else {
      return "-";
    }
  };
}

export default UniProfile;
